import { useState } from "react";

/**
 * Hook to manage avatar state in the About Me section
 */
export function useAvatarState(initialAvatarUrl: string | null = null) {
  const [avatarValue, setAvatarValue] = useState<string | null>(
    initialAvatarUrl
  );
  const [avatarFile, setAvatarFile] = useState<File | null>(null);
  const [processedBlob, setProcessedBlob] = useState<Blob | null>(null);
  const [isUploadingAvatar, setIsUploadingAvatar] = useState(false);

  const handleAvatarChange = (avatarUrl: string) => {
    // Since we're uploading immediately, we just store the Supabase URL
    setAvatarValue(avatarUrl);
    // Clear any previous file/blob state since upload is done
    setAvatarFile(null);
    setProcessedBlob(null);
  };

  return {
    avatarValue,
    avatarFile,
    processedBlob,
    isUploadingAvatar,
    setAvatarValue,
    setAvatarFile,
    setProcessedBlob,
    setIsUploadingAvatar,
    handleAvatarChange,
  };
}
